<form [formGroup]='formGroup'
      class='widget'>
  <div class='form-group'>
    <div class="text-label">
      <pt-input-label
        *ngIf='label'
        [fontWeightBold]='fontWeightBold'
        [inputId]='inputId'
        [isRequired]='required'
        [label]='label'
        style='display: contents'>

      </pt-input-label>

      <div><ng-content></ng-content></div>
    </div>

    <input [class.is-invalid]='isChanged && formGroup.invalid'
           [id]='inputId'
           [maxlength]='maxTextLength'
           aria-describedby='ptWInputHelp'
           autocomplete='off'
           class='form-control form-control-sm'
           formControlName='value'
           placeholder='{{placeholder}}'
           type='text'>
    <small [innerHTML]='help'
           class='form-text text-muted' id='ptWInputHelp_{{controlName}}'>
    </small>
    <div *ngIf="maxTextLength" class="form-text" style="text-align: right">{{formGroup.controls.value.value?.length || 0}}/{{maxTextLength}}</div>

  </div>
</form>
